<template>
	<div class="dropdown">
		<button
			class="btn btn-secondary btn-sm dropdown-toggle"
			type="button"
			@click="open = !open"
			data-bs-toggle="dropdown"
			:id="'dropdown-' + componentUUID"
		>
			{{ text }}
		</button>
		<ul
			class="dropdown-menu user-select-none"
			:aria-labelledby="'dropdown-' + componentUUID"
		>
			<li v-for="(option, index) in options" :key="index" @click.stop="">
				<label class="dropdown-item">
					<input
						type="checkbox"
						:checked="option.enabled"
						@change="$emit('toggle', index)"
					/>
					{{ option.title }}
				</label>
			</li>
		</ul>
	</div>
</template>

<script lang="ts">
import { useUUID } from "@/hooks/useUUID";
import { defineComponent } from "vue";

export type SelectDropdownOption = {
	value: string;
	title: string;
	enabled: boolean;
};

export default defineComponent({
	props: {
		text: {
			type: String,
			default: "Select",
		},
		options: {
			type: Array as () => SelectDropdownOption[],
			required: true,
		},
	},
	setup() {
		const componentUUID = useUUID();
		return { componentUUID };
	},
});
</script>
